// extracted by mini-css-extract-plugin
export default {"display_todos":"DisplayTodos_display_todos__EYqNW","buttons":"DisplayTodos_buttons__I-3Xu","button":"DisplayTodos_button__IpGRK","list_todos":"DisplayTodos_list_todos__tPjpO"};